import { render, staticRenderFns } from "./formattedRole.vue?vue&type=template&id=7012854e"
import script from "./formattedRole.vue?vue&type=script&lang=js"
export * from "./formattedRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports